import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { CheckCircle, ArrowRight, Phone } from "lucide-react";
import { Button } from "@/components/ui/button";

const ConfirmationStep = () => {
  return (
    <motion.div
      initial={{ opacity: 0, scale: 0.95 }}
      animate={{ opacity: 1, scale: 1 }}
      className="text-center py-8"
    >
      <motion.div
        initial={{ scale: 0 }}
        animate={{ scale: 1 }}
        transition={{ delay: 0.2, type: "spring", stiffness: 200 }}
        className="w-20 h-20 bg-primary/20 rounded-full flex items-center justify-center mx-auto mb-6"
      >
        <CheckCircle className="w-10 h-10 text-primary" />
      </motion.div>

      <motion.h2
        initial={{ opacity: 0, y: 10 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ delay: 0.3 }}
        className="font-serif text-3xl md:text-4xl font-bold text-foreground mb-4"
      >
        Thank You!
      </motion.h2>

      <motion.p
        initial={{ opacity: 0, y: 10 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ delay: 0.4 }}
        className="text-lg text-muted-foreground mb-8 max-w-md mx-auto"
      >
        Your estimate request has been submitted successfully. One of our flooring
        experts will contact you within 24 hours to confirm your appointment.
      </motion.p>

      <motion.div
        initial={{ opacity: 0, y: 10 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ delay: 0.5 }}
        className="bg-muted rounded-xl p-6 max-w-md mx-auto mb-8"
      >
        <h3 className="font-semibold text-foreground mb-2">What happens next?</h3>
        <ul className="text-sm text-muted-foreground text-left space-y-2">
          <li className="flex items-start gap-2">
            <span className="text-primary">1.</span>
            Our team will call you to confirm your appointment
          </li>
          <li className="flex items-start gap-2">
            <span className="text-primary">2.</span>
            A flooring expert will visit your home at the scheduled time
          </li>
          <li className="flex items-start gap-2">
            <span className="text-primary">3.</span>
            We'll measure your space and discuss your flooring options
          </li>
          <li className="flex items-start gap-2">
            <span className="text-primary">4.</span>
            You'll receive a detailed, all-inclusive estimate
          </li>
        </ul>
      </motion.div>

      <motion.div
        initial={{ opacity: 0, y: 10 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ delay: 0.6 }}
        className="flex flex-col sm:flex-row gap-4 justify-center"
      >
        <Button asChild variant="coral" size="lg" className="gap-2">
          <Link to="/shop/hardwood">
            Browse Our Collections
            <ArrowRight className="w-4 h-4" />
          </Link>
        </Button>
        <Button asChild variant="outline" size="lg" className="gap-2">
          <a href="tel:+17043892166">
            <Phone className="w-4 h-4" />
            Call (704) 389-2166
          </a>
        </Button>
      </motion.div>
    </motion.div>
  );
};

export default ConfirmationStep;
